import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Spacer } from "@bw/bits"
import { Select, FormField } from "@bw/forms"
import { Formik, Form, Field } from "formik"
import { useTranslation } from "react-i18next"

const initialValues = {
  category: null,
  type: null,
}

const ListFilters = ({ items, children }) => {
  const { t } = useTranslation()
  const [filters, setFilters] = React.useState(initialValues)

  /**
   * Get the existing Categories and Types amongst the items
   */
  const { categories, types } = React.useMemo(() => {
    const triage = items.reduce(
      (acc, item) => {
        item.category?.forEach(category => {
          if (typeof acc.categories[category.slug] === "undefined") {
            acc.categories[category.slug] = {
              value: category.slug,
              label: category.title,
            }
          }
        })

        item.type?.forEach(type => {
          if (typeof acc.types[type.slug] === "undefined") {
            acc.types[type.slug] = {
              value: type.slug,
              label: type.title,
            }
          }
        })

        return acc
      },
      {
        categories: {},
        types: {},
      }
    )

    return {
      categories: Object.values(triage.categories),
      types: Object.values(triage.types),
    }
  }, items)

  const filteredItems = React.useMemo(() => {
    let results = items

    if (filters.category) {
      results = results.filter(item =>
        item.category.find(c => c.slug === filters.category)
      )
    }

    if (filters.type) {
      results = results.filter(item =>
        item.type.find(c => c.slug === filters.type)
      )
    }

    return results
  }, [filters])

  return (
    <>
      <Filters>
        <Formik
          initialValues={initialValues}
          onSubmit={value => {
            setFilters(value)
          }}
        >
          {formik => (
            <Form>
              <Spacer direction="row">
                {categories.length > 1 && (
                  <FormField name="category" title={t("filter.byCategory")}>
                    <Field
                      name="category"
                      options={categories}
                      component={Select}
                      onChange={formik.submitForm}
                    />
                  </FormField>
                )}
                {types.length > 1 && (
                  <FormField name="type" title={t("filter.byType")}>
                    <Field
                      name="type"
                      options={types}
                      component={Select}
                      onChange={formik.submitForm}
                    />
                  </FormField>
                )}
              </Spacer>
            </Form>
          )}
        </Formik>
      </Filters>
      {children({ items: filteredItems })}
    </>
  )
}

ListFilters.propTypes = {
  items: PropTypes.array,
}

const Filters = styled.div`
  margin-bottom: 20px;

  .spacer {
    justify-content: flex-end;
  }
`

export { ListFilters }
